import { Dialog } from '@cmsgov/ds-medicare-gov';
import { useEffect, useState } from 'react';
import StackingButtons from './StackingButtons';
import { useHistory } from 'react-router';
import translate from '../functions/translate';
import CancelButton from './CancelButton';
import OkButton from './OkButton';
import { modalImpression } from '../analytics';

export const PrivacyActDialog = () => {
    const [isOpen, setIsOpen] = useState(true);
    const history = useHistory();

    const cancel = () => {
        history.push('/login');
    };

    const ok = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        if (isOpen) {
            modalImpression(translate('cms_collects_info'));
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <Dialog
            className="privacy-act"
            getApplicationNode={() => document.getElementById('App')}
            headerClassName={'drawer-dialog-header'}
            underlayClickExits={false}
        >
            {translate('cms_collects_info')}
            <br />
            <br />
            {translate('cms_use_disclose_beneficiaries')}
            <StackingButtons
                button1={<CancelButton onClick={cancel} />}
                button2={<OkButton onClick={ok} />}
            />
        </Dialog>
    );
};
